import {ContactRequest} from '../../../models/requests/contact.request';
import axios from '../../../utilities/axios';

export const contactRequest = async (request: ContactRequest): Promise<void> => {
  try {
    const params = new URLSearchParams({
      email: request.email,
      phone: request.phone,
      subject: request.subject,
      body: request.body,
    });
    if (request.name) {
      params.set('name', request.name);
    }
    if (request.url) {
      params.set('url', request.url);
    }
    const config = {
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    }
    const response = await axios.post<void>(
      `${process.env.REACT_APP_BASE_URL_AUTO_LOGIN}/contact/bosyok-do`,
      params,
      config,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
